module.exports = __webpack_public_path__ + "media/images/time-abc539096a48add31ab88be52f321b4a.png";